export default function groupBy<T extends Record<string, any>>(source: T[], key: keyof T): Record<T[keyof T], T[]> {
    return source.reduce((map, item) => {
        if (!map[item[key]])
            map[item[key]] = [];

        if (item != null) {
            map[item[key]].push(item);
        }

        return map;
    }, {} as Record<T[keyof T], T[]>);
}